import { create } from 'zustand';

type HoverStoreType = {
  /** Id of the entity currently hovered on either surface (list or canvas). */
  hoveredId: string | null;
  setHovered: (id: string | null) => void;
  clear: () => void;
};

const useHover = create<HoverStoreType>((set, get) => ({
  hoveredId: null,

  setHovered: (id: string | null) => {
    if (get().hoveredId === id) return;
    set({ hoveredId: id });
  },

  clear: () => {
    if (get().hoveredId === null) return;
    set({ hoveredId: null });
  },
}));

export const useIsNodeHovered = (id: string) =>
  useHover((state) => state.hoveredId === id);

export const { getState: getHoverState } = useHover;

export default useHover;
